import script from "./DndReorderElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./DndReorderElement.vue?vue&type=script&lang=ts&setup=true"

import "./DndReorderElement.vue?vue&type=style&index=0&id=485c775c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485c775c"]])

export default __exports__